<div class="ms-3 mt-4 mb-2" style="overflow-x: auto;">
  {{table.title}}
  @if (!table.skipDownload) {
    <button type="button" class="btn btn-primary"
      (click)="downloadTable('api/control/report/table-export') ">
      <lucide-icon name="cloud-download" size="16"></lucide-icon>
      {{'DATATABLE.DOWNLOAD' |
      translate}}
    </button>
  }
  <table class="mt-4 mb-2 table table-stripped" style="margin: 0 auto;">
    <thead>
      @for (colGroups of table?.value?.columns; track colGroups) {
        <tr>
          @for (colH of colGroups; track colH) {
            <th class="text-center" style="min-width: 280px;" [attr.rowspan]="colH.rowspan"
            [attr.colspan]="colH.colspan">{{colH.name}}</th>
          }
        </tr>
      }
    </thead>
    @for (row of table?.value?.rows; track row; let rowIndex = $index) {
      <tr style="border-bottom: 1px solid var(--border);">
        @for (rowElement of row; track rowElement; let index = $index) {
          <td style="height: 50px;">
            <div>
              @switch (findCol(table?.value?.columns,rowElement.key).type) {
                @case ('static') {
                  <div class="form-group me-1 mt-2"
                    style="text-align: center;">{{rowElement.value}}
                  </div>
                }
                @case ('checkbox') {
                  <div class="form-group me-2">
                    <app-checkbox class="form-group me-1 pb-4" style="text-align: center;"
                      [inTable]="true"
                      [checkbox]="rowElement"
                      [targets]="findCol(table?.value?.columns,rowElement.key).targets"
                    (onValueSelected)="onComponentChange(rowIndex, index, rowElement.key, $event, rowElement)"></app-checkbox>
                  </div>
                }
                @case ('radio') {
                  <div class="form-group me-2">
                    <app-radio class="form-group me-1 pb-4" style="text-align: center;"
                      [inTable]="true"
                      [rowKeyIndex] = "table.key+'_'+rowIndex"
                      [radio]="rowElement"
                      [targets]="findCol(table?.value?.columns,rowElement.key).targets"
                    (onValueSelected)="onComponentChange(rowIndex, index, rowElement.key, $event, rowElement)"></app-radio>
                  </div>
                }
                @case ('select') {
                  <div class="form-group me-2">
                    <app-select [select]="rowElement"
                      [targets]="findCol(table?.value?.columns,rowElement.key).targets"
                      [inTable]="true"
                    (onValueSelected)="onComponentChange(rowIndex, index, rowElement.key, $event, rowElement)"></app-select>
                  </div>
                }
                @case ('calendar') {
                  <div class="form-group me-2">
                    <app-calendar [calendarElem] = "rowElement"
                      [inTable]="true"
                      (onDateSet)="onCalendarChange(rowIndex, index, rowElement.key, $event, rowElement)"
                      >
                    </app-calendar>
                  </div>
                }
                @case ('textarea') {
                  <div class="form-group me-2">
                    <textarea class="form-control" id="{{rowElement.key}}"
                      value={{rowElement.value}}
                      style="min-width: 200px; min-height: 200px;"
                      name="{{rowElement.key}}"
                      (change)="onChange(rowIndex, index, rowElement.key, $event.target.value)">
                    </textarea>
                  </div>
                }
                @default {
                  <div class="form-group me-2">
                    @if (findCol(table?.value?.columns,rowElement.key).type==='number') {
                      <input
                        [OnlyNumber]="true" thousandSeparator pattern="[0-9]+([\.,][0-9]+)*"
                        class="form-control" id="{{rowElement.key}}"
                        value={{rowElement.value|thousandSeparator}}
                        style="min-width: 200px;" name="{{rowElement.key}}"
                        (change)="onChange(rowIndex, index, rowElement.key, $event.target.value)">
                    } @else {
                      <input class="form-control" id="{{rowElement.key}}"
                        type="{{findCol(table?.value?.columns,rowElement.key).type}}"
                        value={{rowElement.value}}
                        style="min-width: 200px;" name="{{rowElement.key}}"
                        (change)="onChange(rowIndex, index, rowElement.key, $event.target.value)">
                      }
                    </div>
                  }
                }
              </div>
            </td>
          }
        </tr>
      }
    </table>

  </div>
